import { render, staticRenderFns } from "./dataTabs.vue?vue&type=template&id=538ae352&scoped=true&"
import script from "./dataTabs.vue?vue&type=script&lang=js&"
export * from "./dataTabs.vue?vue&type=script&lang=js&"
import style0 from "./dataTabs.vue?vue&type=style&index=0&id=538ae352&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538ae352",
  null
  
)

export default component.exports